module.exports = __webpack_public_path__ + "media/images/emblems/Hofstetten_bei_Brienz-coat_of_arms-e230101c1254e50c6497331c63674580.svg";